import React, { useEffect, useRef } from "react";
import "./Main.css";

function Main() {
  const contentRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.3 }
    );

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const scrollToCatalog = () => {
    const element = document.getElementById("Price");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="main hero-m" id="Main" >
      {/* <div className="main-background">
        <div className="main-overlay"></div>
        <div className="main-pattern"></div>
      </div>
      
      <div className="main-container">
        <div className="main-content" ref={contentRef}>
          <span className="main-greeting">👋 Привет, я Дарья</span>
          
          <h1 className="main-title">
            Сделай свою <br />
            <span className="title-highlight">жизнь слаще</span>
          </h1>
          
          <div className="main-description">
            <p className="main-text">
              Кондитер в городе Чехов с 5-летним опытом. Создаю десерты, 
              которые радуют вкусом и дарят незабываемые моменты.
            </p>
          </div>

          <div className="main-actions">
            <button className="main-button primary" onClick={scrollToCatalog}>
              <span>Перейти в каталог</span>
              <span className="button-arrow">→</span>
            </button>
            
            <a href="#About" className="main-link">
              Узнать больше
            </a>
          </div>

          <div className="main-features">
            <div className="feature-item">
              <span className="feature-icon">🎂</span>
              <span className="feature-text">Авторские рецепты</span>
            </div>
            <div className="feature-divider"></div>
            <div className="feature-item">
              <span className="feature-icon">✨</span>
              <span className="feature-text">Свежие ингредиенты</span>
            </div>
            <div className="feature-divider"></div>
            <div className="feature-item">
              <span className="feature-icon">❤️</span>
              <span className="feature-text">С любовью к деталям</span>
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-hint">
        <span className="scroll-text">Листай вниз</span>
        <span className="scroll-arrow">↓</span>
      </div> */}
      <div className="hero-container">
        <div className="hero-content">
          {/* <div className="hero-badge">
            <span>✨</span>
            <span>Профессиональные материалы для кондитеров</span>
          </div> */}
          
          <h1 className="hero-title">
            Сделай свою <span className="highlight">жизнь</span> слаще
          </h1>
          
          <p className="hero-subtitle">
            Кондитер в городе Чехов с 6-летним опытом. Создаю десерты, которые радуют вкусом и дарят незабываемые моменты.
          </p>
          
          <div className="hero-features">
            <div className="hero-feature">
              <span className="feature-icon">🎯</span>
              <span>Индивидуальный подход</span>
            </div>
            <div className="hero-feature">
              <span className="feature-icon">✨</span>
              <span>Качественные ингредиенты</span>
            </div>
            <div className="hero-feature">
              <span className="feature-icon">💝</span>
              <span>Лучшие цены</span>
            </div>
          </div>
          
          {/* <div className="hero-buttons">
            <a href="#catalog" className="hero-button hero-button-primary">
              <span>🛍️</span>
              <span>В каталог</span>
            </a>
            <a href="#about" className="hero-button hero-button-secondary">
              <span>📖</span>
              <span>О нас</span>
            </a>
          </div> */}
           <div className="main-actions">
            <button className="main-button primary" onClick={scrollToCatalog}>
              <span>Перейти в каталог</span>
              <span className="button-arrow">→</span>
            </button>
          </div>
        </div>
        
        
        
        <div className="hero-image">
          <div className="hero-image-wrapper">
            <img 
              src="https://storage.yandexcloud.net/dashacakes.store/photo/Store/IMG_0468.JPG" 
              alt="Cake decorating" 
              className="hero-image-main"
            />
          </div>
          
          <div className="floating-card card-1">
            <div className="floating-card-icon">🏆</div>
            <div className="floating-card-text">1000+</div>
            <div className="floating-card-subtext">довольных клиентов</div>
          </div>
          
          <div className="floating-card card-2">
            <div className="floating-card-icon">⭐</div>
            <div className="floating-card-text">6+</div>
            <div className="floating-card-subtext">лет опыта</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Main;